import { Language } from '@mui/icons-material'
import { Box, Button, Tooltip } from '@mui/material'
import DashboardCard from '@storage/components/DashboardCard'
import { useTranslate } from '@tolgee/react'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { DashboardCardType } from '../types/yard-planning-dashboard.types'
import { getDashboardCardSubtitle } from '../utils/yard-planning-dashboard.util'

interface YardPlanningDashboardHeaderProps {
  totalYardBlock: number
  totalContainerTurnovers: number
  totalIssues?: number
  yardInconsistencies: number
  skipYardPlanning: boolean
}
const YardPlanningDashboardHeader = observer(
  ({
    totalYardBlock,
    totalContainerTurnovers,
    yardInconsistencies,
    skipYardPlanning,
  }: YardPlanningDashboardHeaderProps) => {
    const { t } = useTranslate()
    const navigate = useNavigate()

    return (
      <Box sx={{ display: 'flex', gap: 3, p: 1 }}>
        <DashboardCard
          sxProps={{ minWidth: '382px' }}
          title={t('yardView', 'Yard View')}
          subtitle={getDashboardCardSubtitle(DashboardCardType.Block, totalYardBlock)}
          actionRoute={PATHS.yard.management.url}
        />

        <DashboardCard
          sxProps={{ minWidth: '382px' }}
          title={t('containerTurnovers', 'Container Turnovers')}
          subtitle={getDashboardCardSubtitle(DashboardCardType.Container, totalContainerTurnovers)}
          actionRoute={PATHS.yard.containerTurnovers.url}
        />

        {/* <DashboardCard
        sxProps={{ width: '382px' }}
        title={t('issues', 'Issues')}
        subtitle={<LabelBox label={`${totalIssues} ${t('inTotal', 'in Total')}`} />}
        icon={ReportProblem}
        actionRoute={PATH_STORAGE.yardPlanningIssues}
      /> */}

        <DashboardCard
          sxProps={{ minWidth: '382px' }}
          title={t('yardInconsistencies', 'Yard Inconsistencies')}
          subtitle={getDashboardCardSubtitle(DashboardCardType.Issue, yardInconsistencies)}
          subtitleColor={yardInconsistencies > 0 ? 'warning' : 'secondary'}
          actionRoute={PATHS.yard.inconsistencies.url}
          isActionDisabled={yardInconsistencies === 0}
        />

        {!skipYardPlanning && (
          <Tooltip
            title={t(
              'globalRulesTooltip',
              'Great for containers that come to the terminal and always go to the same spaces. You can override global rules when planning individual visits.',
            )}
          >
            <Button
              startIcon={<Language />}
              data-cy='global-allocation-rules-button'
              onClick={() => navigate(PATHS.yard.globalAllocationRules.url)}
            >
              {t('globalRules', 'Global Rules')}
            </Button>
          </Tooltip>
        )}
      </Box>
    )
  },
)

export default YardPlanningDashboardHeader
